/**
 * Quien se desplaza alrededor de un elemento: el área de contenido del shell, el cuerpo de una hoja o
 * el panel del pedido. Donde no hay maquetación (una prueba sin navegador) no hay ninguno.
 */
export function scrollParentOf(element: HTMLElement): HTMLElement | null {
  for (let parent = element.parentElement; parent; parent = parent.parentElement) {
    const overflow = getComputedStyle(parent).overflowY;
    if (overflow === 'auto' || overflow === 'scroll') return parent;
  }
  return null;
}
